export const DAC_AUTH_LOGIN         = 'api/auth/login';
export const DAC_AUTH_CLOSE         = 'api/auth/close';
export const DAC_AUTH_SENDOTP       = 'api/auth/sendOtp';
export const DAC_AUTH_VALIDATEOTP   = 'api/auth/validateOtp';
export const DAC_AUTH_REFRESH_TOKEN = 'api/auth/refreshToken';
export const DAC_AUTH_UPDATEPWD     = 'api/auth/resetPassword';
export const DAC_AUTH_CHANGE_PASSWORD_SEND_CODE = 'api/auth/changePassword/sendCode';
export const DAC_AUTH_CHANGE_PASSWORD_CONFIRM = 'api/auth/changePassword/confirm';
export const DAC_AUTH_CSRF          = 'api/auth/csrf';
export const DAC_AUTH_SESSION       = 'api/auth/session';
export const DAC_HOME_CONTINUITY_SUMMARY = 'api/home/continuity-summary';
export const DAC_USER_LIST          = 'api/user/list';
export const DAC_USER_GET           = 'api/user/list/';
export const DAC_USER_SAVE          = 'api/user/create';
export const DAC_USER_UPDATE        = 'api/user/update/';
export const DAC_USER_PROFESSIONAL_PROFILE = 'api/user/professional-profile/';
export const DAC_USER_PROFESSIONAL_PROFILE_ME = 'api/user/professional-profile/me';
export const DAC_ROL_LIST           = 'api/rol/list';
export const DAC_ROL_PERMISSIONS    = 'api/rol/permissions/';
export const DAC_BIRTHDAY_LIST      = 'api/px/birthday';
export const DAC_PX_SEARCHER        = 'api/px/search';
export const DAC_PX_SEARCH_FAST     = 'api/px/search-fast';
export const DAC_FAMILY_PATH        = 'api/px/family-path';
export const DAC_PX_CREATE_MINIMAL  = 'api/px/create-minimal';
export const DAC_PX_SAVE            = 'api/px/save';
export const DAC_PX_UPDATE          = 'api/px/update';
export const DAC_PX_BY_ID           = 'api/px/get/';
export const DAC_PX_DELETE          = 'api/px/delete';
export const DAC_PATOLOGIC_SECTION  = 'api/catalog/SectionsPathological';
export const DAC_PATOLOGICAL        = 'api/catalog/Pathological';
export const DAC_FILE               = 'api/catalog/Files';
export const DAC_FILE_PROFILE       = 'api/file/px/upload-profile';
export const DAC_FILE_PHOTO         = 'api/file/px/upload-file';
export const DAC_GET_PHOTOS         = 'api/file/px/file/';
export const DAC_DELETE_PHOTO       = 'api/file/delete';
export const DAC_ADD_MONITORING     = 'api/tracing/save';
export const DAC_UPD_MONITORING     = 'api/tracing/UPDATE';
export const DAC_GET_MONITORING     = 'api/tracing/list/';
export const DAC_DELETE_MONITORING  = 'api/tracing/delete';
export const DAC_GET_ALL_MONITORING = 'api/tracing/next';
export const DAC_ODONTOGRAM_GET     = 'api/teeth/list/';
export const DAC_CONDITIONS_GET     = 'api/catalog/teeth/condition';
export const DAC_ADD_OTREATMENT     = 'api/treatment/save';
export const DAC_UPD_OTREATMENT     = 'api/treatment/update';
export const DAC_GET_OTREATMENT     = 'api/treatment/list/';
export const DAC_GET_PX_TREATMENT   = 'api/treatment/cat/list/';
export const DAC_DELETE_OTREATMENT  = 'api/treatment/delete';
export const DAC_TREATMENT_PLAN_GET = 'api/treatment/plan/';
export const DAC_TREATMENT_PLAN_CREATE = 'api/treatment/plan/create';
export const DAC_TREATMENT_PLAN_UPDATE = 'api/treatment/plan/update';
export const DAC_TREATMENT_PLAN_CLOSE = 'api/treatment/plan/close';
export const DAC_TREATMENT_PLAN_SAVE_TREATMENT = 'api/treatment/plan/treatment/save';
export const DAC_TREATMENT_PLAN_STATUS = 'api/treatment/plan/treatment/status';
export const DAC_TREATMENT_PLAN_DELETE_TREATMENT = 'api/treatment/plan/treatment/delete';
export const DAC_TREATMENT_PLAN_CONSENT_SAVE = 'api/treatment/plan/consent/save';
// Prepared plan consent uses the shared document signature flow.
export const DAC_TREATMENT_PLAN_CONSENT_PREPARE = 'api/treatment/plan/consent/prepare';
export const DAC_TREATMENT_PLAN_CONSENT_DOCUMENT_SIGN = 'api/treatment/plan/consent/document/sign';
export const DAC_ODONTOGRAM_GET_TOOTH   = 'api/odontogram/get/tooth/';
// export const DAC_ODONTOGRAM_SAVE        = 'api/odontogram/save';
export const DAC_ODONTOGRAM_UPDATE      = 'api/odontogram/update';
export const DAC_CONFIG_SAVE        = "/api/config/signatureconten/save";
export const DAC_CONFIG_GET          = "/api/config/signatureconten/get";
export const DAC_CONFIG_UPDATE       = "/api/config/signatureconten/update";
export const DAC_CONFIG_LOGIN_IMAGE_SAVE = "/api/config/login-image/save";
export const DAC_CONFIG_LOGIN_IMAGE_GET  = "/api/config/login-image/get";
export const DAC_CONFIG_THEME_LIST       = "/api/config/theme/list";
export const DAC_CONFIG_THEME_GET        = "/api/config/theme/get";
export const DAC_CONFIG_THEME_SAVE       = "/api/config/theme/save";
export const DAC_CONFIG_CLINICAL_MODULES_GET  = "/api/config/clinical-modules/get";
export const DAC_CONFIG_CLINICAL_MODULES_SAVE = "/api/config/clinical-modules/save";
export const DAC_APPOINTMENT_CONFIG_GET  = "/api/appointment/config";
export const DAC_APPOINTMENT_CONFIG_SAVE = "/api/appointment/config/save";
export const DAC_APPOINTMENT_LIST        = "/api/appointment/list";
export const DAC_APPOINTMENT_PATIENT_HISTORY = (patientId) => `/api/appointment/patient/${patientId}/history`;
export const DAC_APPOINTMENT_SAVE        = "/api/appointment/save";
export const DAC_APPOINTMENT_DELETE      = "/api/appointment/delete";
export const DAC_BUSINESS_CURRENT        = "/api/business/current";
export const DAC_BUSINESS_DASHBOARD_SUMMARY = "/api/business/dashboard/summary";
export const DAC_BUSINESS_DASHBOARD_TRENDS = "/api/business/dashboard/trends";
export const DAC_BUSINESS_DASHBOARD_OPERATIONAL_SUMMARY = "/api/business/dashboard/operational-summary";
export const DAC_BUSINESS_DASHBOARD_PROFESSIONAL_BREAKDOWN = "/api/business/dashboard/professional-breakdown";
export const DAC_BUSINESS_DASHBOARD_TEAM_BREAKDOWN = "/api/business/dashboard/team-breakdown";
export const DAC_SUPER_ADMIN_BUSINESSES  = "/api/super-admin/businesses";
export const DAC_SUPER_ADMIN_BUSINESS_OPTIONS = "/api/super-admin/business-options";
export const DAC_SUPER_ADMIN_AUDIT       = "/api/super-admin/audit";
export const DAC_SUPER_ADMIN_DASHBOARD_SUMMARY = "/api/super-admin/dashboard/summary";
export const DAC_SUPER_ADMIN_SAAS_JOBS_STATUS = "/api/super-admin/jobs/saas/status";
export const DAC_SUPER_ADMIN_SAAS_TRIAL_LIFECYCLE_RUN = "/api/super-admin/jobs/saas/trial-lifecycle/run";
export const DAC_SUPER_ADMIN_PLANS       = "/api/super-admin/plans";
export const DAC_SUPER_ADMIN_USERS       = "/api/super-admin/users";
export const DAC_SUPER_ADMIN_SESSIONS    = "/api/super-admin/sessions";
export const DAC_SUPER_ADMIN_USER_SESSIONS = "/api/super-admin/users";
export const DAC_SUPER_ADMIN_BUSINESS_SUBSCRIPTION_STATUS = "/api/super-admin/businesses";
export const DAC_SUPER_ADMIN_BUSINESS_TRIAL = "/api/super-admin/businesses";
export const DAC_SUPER_ADMIN_BUSINESS_PLAN = "/api/super-admin/businesses";
export const DAC_SUPER_ADMIN_BUSINESS_LICENSE_OVERRIDES = "/api/super-admin/businesses";
export const DAC_PRESCRIPTION_CONFIG_GET = "/api/prescription/config";
export const DAC_PRESCRIPTION_CONFIG_SAVE = "/api/prescription/config/save";
export const DAC_PRESCRIPTION_LIST       = "/api/prescription/list";
export const DAC_PRESCRIPTION_PATIENT    = "/api/prescription/patient/";
export const DAC_PRESCRIPTION_DOCTORS    = "/api/prescription/doctors";
export const DAC_PRESCRIPTION_GET        = "/api/prescription/";
export const DAC_PRESCRIPTION_SAVE       = "/api/prescription/save";
export const DAC_PRESCRIPTION_ISSUE      = "/api/prescription/issue";
export const DAC_PRESCRIPTION_CANCEL     = "/api/prescription/cancel";
export const DAC_PRESCRIPTION_DELETE_DRAFT = "/api/prescription/draft";
export const DAC_PRESCRIPTION_AUDIT_ACTION = "/api/prescription/audit-action";
export const DAC_PRESCRIPTION_OUTPUT = "/api/prescription/output";
export const DAC_DOCUMENT_TEMPLATES       = "/api/document/templates";
export const DAC_DOCUMENT_TEMPLATE_SAVE   = "/api/document/template/save";
export const DAC_DOCUMENT_PATIENT         = "/api/document/patient/";
export const DAC_DOCUMENT_CREATE          = "/api/document/create";
export const DAC_DOCUMENT_SIGN            = "/api/document/sign";
export const DAC_DOCUMENT_REFUSAL         = "/api/document/refusal";
export const DAC_DOCUMENT_CANCEL          = "/api/document/cancel";
export const DAC_DOCUMENT_AUDIT_ACTION    = "/api/document/audit-action";
export const DAC_DOCUMENT_SIGNATURE_REQUEST_CREATE = "/api/document/signature-request/create";
export const DAC_DOCUMENT_SIGNATURE_REQUEST_EMAIL = "/api/document/signature-request/email";
export const DAC_DOCUMENT_SIGNATURE_REQUEST_LIST = (idPatientDocument) => `/api/document/signature-request/list/${idPatientDocument}`;
export const DAC_DOCUMENT_SIGNATURE_REQUEST_REVOKE = "/api/document/signature-request/revoke";
export const DAC_PUBLIC_DOCUMENT_SIGNATURE = "/api/public/document-signature/";
export const DAC_PUBLIC_DOCUMENT_SIGNATURE_SIGN = (token) => `/api/public/document-signature/${token}/sign`;
export const DAC_CLINICAL_HISTORY_PATIENT = "/api/clinical-history/patient/";
export const DAC_CLINICAL_HISTORY_GET     = "/api/clinical-history/";
export const DAC_CLINICAL_HISTORY_DRAFT   = "/api/clinical-history/draft";
export const DAC_CLINICAL_HISTORY_FINALIZE = "/api/clinical-history/";
export const DAC_CLINICAL_HISTORY_CANCEL   = "/api/clinical-history/";
export const DAC_CLINICAL_HISTORY_TEMPLATE_CURRENT = "/api/clinical-history-template/current";
export const DAC_CLINICAL_HISTORY_TEMPLATE_BUSINESS = "/api/clinical-history-template/business";
export const DAC_CLINICAL_HISTORY_TEMPLATE_VERSION = "/api/clinical-history-template/";
export const DAC_ODONTOGRAM_TYPE_TOOTH  = "/api/odontogram/getcatypetooth";
export const DAC_TRATAMENT_GET  = "/api/treatment/diagnosis/get/";
export const DAC_TRATAMENT_SAVED  = "/api/treatment/diagnosis/save";

export const DAC_ODONTOGRAM_VALIDATE     = 'api/odontogram/v1/validate/';
export const DAC_ODONTOGRAM_PARENT_SAVE     = 'api/odontogram/v1/save';
export const DAC_ODONTOGRAM_DETAIL_SAVE     = 'api/odontogram/v1/detail';
export const DAC_ODONTOGRAM_DETAIL_GET     = 'api/odontogram/v1/odontogram/';
export const DAC_ODONTOGRAM_HISTORY_GET     = 'api/odontogram/v1/history/';
export const DAC_ODONTOGRAM_STATUS      = 'api/odontogram/v1/status';
export const DAC_ODONTOGRAM_DELETE      = 'api/odontogram/v1/delete';
